import { Component, h, Host, Prop, State } from "@stencil/core";
import { ServiceDocument } from "../../api/publicApi/serviceReports/document";
import { ReportItem } from "./report-row";

@Component({
    tag: "mf-service-reports-paginated-items"
})
export class PaginatedReportItems {
    private static pageSize = 5;
    /** The list of service documents to display */
    @Prop() items: ServiceDocument[] = [];
    /** The function to translate keys */
    @Prop() t: (key: string, options?: Record<string, unknown>) => string;
    /** Whether the component is used on a machine page */
    @Prop() isOnMachinePage: boolean = false;
    @State() visibleAmount: number = PaginatedReportItems.pageSize;

    /**
     * Load more items when the button is clicked
     */
    private loadMore() {
        this.visibleAmount += PaginatedReportItems.pageSize;
    }

    render() {
        return (
            <Host>
                {this.items.slice(0, this.visibleAmount).map((doc) => (
                    <div class="ux-info-box">
                        <ReportItem
                            t={this.t}
                            document={doc}
                            title={this.t(`mf-service-calls:serviceReports.reportTypes.${doc.mission.assignmentType}`)}
                            isOnMachinePage={this.isOnMachinePage}
                        />
                    </div>
                ))}
                {this.visibleAmount < this.items.length && (
                    <ux-button class="mf-service-reports__load-more" onClick={() => this.loadMore()}>
                        {this.t("mf-service-calls:serviceReports.loadMore")}
                    </ux-button>
                )}
            </Host>
        );
    }
}
